import { render, staticRenderFns } from "./transfer_log.vue?vue&type=template&id=45d36a29&scoped=true&"
import script from "./transfer_log.vue?vue&type=script&lang=js&"
export * from "./transfer_log.vue?vue&type=script&lang=js&"
import style0 from "./transfer_log.vue?vue&type=style&index=0&id=45d36a29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d36a29",
  null
  
)

export default component.exports